import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield, CreditCard, AlertTriangle } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { Countdown } from '../ui/Countdown';
const items = [{
  name: 'Tom 1 — PODSTAWY U6-U7',
  value: '150 zł'
}, {
  name: 'Tom 2 — TECHNIKA U8-U9',
  value: '150 zł'
}, {
  name: 'Tom 3 — INTELIGENCJA U10-U11',
  value: '150 zł'
}, {
  name: 'Tom 4 — ZESPÓŁ U12-U13',
  value: '150 zł'
}, {
  name: 'Tom 5 — ATLAS TRENERA',
  value: '150 zł'
}, {
  name: 'Tom 6 — ADMINISTRACJA',
  value: '150 zł'
}, {
  name: '6 Bonusów specjalnych',
  value: '600 zł'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-189">
      <div className="max-w-4xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-2xl shadow-xl overflow-hidden ring-2 ring-gold-accent ring-offset-2 ring-offset-navy-primary relative" data-id="element-191">
          {/* Discount Badge */}
          <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-red-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-full font-bold text-sm md:text-xl shadow-lg z-10 transform rotate-3" data-id="element-192">
            ZNIŻKA
          </div>

          <div className="bg-gradient-to-br from-gold-accent to-gold-light p-6 md:p-8 text-center" data-id="element-193">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-1 md:mb-2 pr-16 md:pr-0" data-id="element-194">
              🏆 Opcja najpopularniejsza — wybierana najczęściej
            </h2>
          </div>

          <div className="p-6 md:p-12" data-id="element-195">
            <h3 className="text-xl md:text-2xl font-display font-bold text-navy-primary mb-4 md:mb-6 text-center" data-id="element-196">
              Łączna wartość wszystkich materiałów:
            </h3>

            <div className="mb-6 md:mb-8 rounded-xl overflow-hidden border border-gray-100" data-id="element-197">
              {items.map((item, index) => <div key={index} className={`flex justify-between items-center px-4 py-2.5 md:py-3 text-sm md:text-base ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`} data-id="element-198">
                  <span className="text-gray-700" data-id="element-199">{item.name}</span>
                  <span className="font-bold text-navy-primary" data-id="element-200">
                    → {item.value}
                  </span>
                </div>)}
            </div>

            <div className="border-t-2 border-gray-200 pt-6 mb-6 md:mb-8" data-id="element-201">
              <div className="flex justify-between items-center mb-4 px-2" data-id="element-202">
                <span className="text-lg md:text-xl font-bold text-gray-600" data-id="element-203">
                  Wartość rzeczywista:
                </span>
                <span className="text-xl md:text-2xl font-bold text-gray-400 line-through" data-id="element-204">
                  1 500 zł
                </span>
              </div>

              <div className="text-center my-6 md:my-8" data-id="element-205">
                <p className="text-xl md:text-2xl font-bold text-navy-primary mb-2" data-id="element-206">
                  🔥 Tylko dzisiaj
                </p>
                <div className="text-6xl sm:text-7xl md:text-8xl font-display font-bold text-gold-accent mb-4 drop-shadow-md" data-id="element-207">
                  73 zł
                </div>
                <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-600" data-id="element-208">
                  <span className="flex items-center gap-1" data-id="element-209">
                    <CreditCard className="w-4 h-4" data-id="element-210" />
                    Jednorazowa płatność
                  </span>
                  <span className="flex items-center gap-1" data-id="element-211">
                    <Zap className="w-4 h-4" data-id="element-212" />
                    Natychmiastowy dostęp
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 md:mb-8 flex items-start gap-3" data-id="element-213">
              <AlertTriangle className="w-5 h-5 md:w-6 md:h-6 text-red-600 flex-shrink-0 mt-0.5" data-id="element-214" />
              <div data-id="element-215">
                <p className="font-bold text-red-700 mb-1 text-sm md:text-base" data-id="element-216">
                  ⚠️ Tylko dla pierwszych 200 trenerów
                </p>
                <p className="text-red-600 text-xs md:text-sm" data-id="element-217">
                  Po tym limicie cena wraca do regularnej
                </p>
              </div>
            </div>

            <a href="https://polonia.recursopack.com/cart/40996883398705:1" className="block mb-5" data-id="element-218">
              <CTAButton size="large" className="w-full" data-id="element-219">
                ⚽ TAK! Chcę 40 tygodni gotowych planów — 73 ZŁ
              </CTAButton>
            </a>

            <div className="flex justify-center mb-5" data-id="element-220">
              <Countdown data-id="element-221" />
            </div>

            <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-600" data-id="element-222">
              <span className="flex items-center gap-1" data-id="element-223">
                <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-224" />
                Natychmiastowy dostęp
              </span>
              <span className="flex items-center gap-1" data-id="element-225">
                <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-226" />
                Jednorazowa płatność
              </span>
              <span className="flex items-center gap-1" data-id="element-227">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-228" />
                Gwarancja 7 dni
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}